<template>
  <main
    class="terms-page"
    data-fullscreen
    data-no-header
    v-background-color="$store.getters['ui/getBackgroundColor']"
    v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
  >
    <main-header
      data-element="main-header"
      :hideTableNumber="true"
    />
    <h3
      data-element="terms-title"
      v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
      v-color="this.$store.getters['ui/getPrimaryColor']"
      v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
      :style="{ fontSize: `20px` }"
    >
      {{ $store.getters['getTermsTitle'] }}
    </h3>
    <vue-markdown
      data-element="terms-content"
      :source="$store.getters['getTermsContent']"
      v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('normal')"
    />
  </main>
</template>

<script>
  import VueMarkdown from 'vue-markdown';
  import MainHeader  from '@/components/ui/MainHeader';

  export default {
    name: 'terms-page',
    components: {
      MainHeader,
      VueMarkdown
    }
  };
</script>


<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';
  @import '@/assets/scss/helpers.scss';

  .terms-page {
    [data-element='terms-title'] {
      padding-top:24px;
    }
    [data-element='terms-content'] {
      padding:32px 20px 0;
      /deep/ h1 {
        text-align:center;
        margin-bottom:10px;
      }
      /deep/ ol, /deep/ li {
        padding-left:10px;
      }
    }
  }
</style>
